import React, { useEffect } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";
import './RichTextEditor.css';

const ToolbarButton = ({ onClick, active, label, children }) => (
    <button
        type="button"
        className={`rte-toolbar-btn${active ? ' rte-toolbar-btn--active' : ''}`}
        onMouseDown={(e) => e.preventDefault()}
        onClick={onClick}
        aria-label={label}
        title={label}
    >
        {children}
    </button>
);

const RichTextEditor = ({ value, onChange, placeholder }) => {
    const editor = useEditor({
        extensions: [
            StarterKit.configure({
                link: { openOnClick: false, autolink: true },
            }),
            Placeholder.configure({ placeholder: placeholder || "Text eingeben…" }),
        ],
        content: value || "",
        editorProps: {
            attributes: {
                class: "rte-content",
            },
        },
        onUpdate: ({ editor }) => {
            onChange(editor.getHTML());
        },
    });

    useEffect(() => {
        if (editor && value !== editor.getHTML() && value !== undefined) {
            const isEmptyIncoming = !value || value === "<p></p>";
            const isEmptyCurrent = editor.isEmpty;
            if (!(isEmptyIncoming && isEmptyCurrent)) {
                editor.commands.setContent(value || "", false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, editor]);

    if (!editor) return null;

    const setLink = () => {
        const previousUrl = editor.getAttributes('link').href;
        const url = window.prompt('Link-URL', previousUrl || 'https://');
        if (url === null) return;
        if (url === '') {
            editor.chain().focus().extendMarkRange('link').unsetLink().run();
            return;
        }
        editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
    };

    return (
        <div className="rte-wrapper">
            <div className="rte-toolbar">
                <ToolbarButton label="Fett" active={editor.isActive('bold')} onClick={() => editor.chain().focus().toggleBold().run()}>B</ToolbarButton>
                <ToolbarButton label="Kursiv" active={editor.isActive('italic')} onClick={() => editor.chain().focus().toggleItalic().run()}><em>I</em></ToolbarButton>
                <span className="rte-toolbar-divider" />
                <ToolbarButton label="Überschrift groß" active={editor.isActive('heading', { level: 2 })} onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}>H2</ToolbarButton>
                <ToolbarButton label="Überschrift klein" active={editor.isActive('heading', { level: 3 })} onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}>H3</ToolbarButton>
                <span className="rte-toolbar-divider" />
                <ToolbarButton label="Aufzählung" active={editor.isActive('bulletList')} onClick={() => editor.chain().focus().toggleBulletList().run()}>•</ToolbarButton>
                <ToolbarButton label="Nummerierte Liste" active={editor.isActive('orderedList')} onClick={() => editor.chain().focus().toggleOrderedList().run()}>1.</ToolbarButton>
                <span className="rte-toolbar-divider" />
                <ToolbarButton label="Link einfügen" active={editor.isActive('link')} onClick={setLink}>🔗</ToolbarButton>
                <span className="rte-toolbar-divider" />
                <ToolbarButton label="Rückgängig" onClick={() => editor.chain().focus().undo().run()}>↺</ToolbarButton>
                <ToolbarButton label="Wiederholen" onClick={() => editor.chain().focus().redo().run()}>↻</ToolbarButton>
            </div>
            <EditorContent editor={editor} />
        </div>
    );
};

export default RichTextEditor;
